var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 14.3298 14.3298",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mynaui:edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.38829 12.5386H11.9415M3.38302 7.87361C3.12844 8.12877 2.98543 8.47447 2.98537 8.83491V10.7473H4.90975C5.27038 10.7473 5.61609 10.604 5.87104 10.3485L11.5433 4.67328C11.7978 4.41809 11.9407 4.07239 11.9407 3.71199C11.9407 3.35159 11.7978 3.00589 11.5433 2.7507L10.9832 2.18945C10.8569 2.06308 10.7069 1.96284 10.5419 1.89447C10.3768 1.8261 10.1999 1.79094 10.0212 1.791C9.84253 1.79105 9.66562 1.82632 9.5006 1.89479C9.33557 1.96327 9.18566 2.06359 9.05943 2.19004L3.38302 7.87361Z",
    stroke: "#5A76C9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.8b1d48f00b81b5b881250e56a823d775.svg";
export { ForwardRef as ReactComponent };